module.exports = __webpack_public_path__ + "img/Groupe 87.7f71b92c.svg";